import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class LogsService {


    static getAllCompanyDevice(CompanyCode, DeviceSerialNumber, email) {
        //var data = [];
        return axios.get(`${BaseUrl}CompanyDevice?CompanyCode=${CompanyCode ? CompanyCode : "" }&DeviceSerialNumber=${DeviceSerialNumber ? DeviceSerialNumber : ""}&email=${email}`);
    }

    static getStatusDevice(CompanyCode, DeviceSerialNumber, email) {
  
        return axios.get(`${BaseUrl}Device?CompanyCode=${CompanyCode ? CompanyCode : "" }&DeviceSerialNumber=${DeviceSerialNumber ? DeviceSerialNumber : ""}&email=${email}`);
    }

}


// WEBPACK FOOTER //
// ./src/Services/CompanyDeviceService/companyDeviceService.js